import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import services from "./services";
import filters from "./filter";
import { TokenService } from "./services/storage";

import "@/assets/scss/custom.scss";
import "bootstrap";
import axios from "axios";

import VueSweetalert2 from "vue-sweetalert2";
import VueSelect from "vue-select";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { far } from "@fortawesome/free-regular-svg-icons";
import { fab } from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

import "vue-select/dist/vue-select.css";
import "sweetalert2/dist/sweetalert2.min.css";
import { defineRule } from "vee-validate";
import VueGoogleMaps from "@fawmi/vue-google-maps";

defineRule("required", (value) => {
  if (value != undefined) {
    value = value.toString();
  }
  if (value && value.trim()) {
    return true;
  }
  return "Field ini wajib diisi";
});
defineRule("email", (value) => {
  // Field is empty, should pass
  if (!value || !value.length) {
    return true;
  }
  // Check if email
  if (!/^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/.test(value)) {
    return "Email tidak Valid";
  }
  return true;
});

const app = createApp(App);
// TODO ADD ENV IN CMS FOR ADMIN
app.use(VueGoogleMaps, {
  load: {
    key: process.env.VUE_APP_MAPS_KEY,
  },
});

console.log(process.env.VUE_APP_API);
services.init(process.env.VUE_APP_API);
// console.log("TOKEN : ",TokenService.getToken())

axios.interceptors.response.use(
  (response) => {
    return response;
  },
  function (error) {
    if (error.response.status === 401) {
      localStorage.access_token = "";
      router.replace("/login");
      return Promise.reject(error);
    }
    return Promise.reject(error);
  }
);

// axios.interceptors.request.use(
//   (config) => {
//     const jwt = this.$session.get('jwt');

//     if (jwt) {
//       config.headers.Authorization = `Bearer ${jwt.token}`;
//     }

//     return config;
//   },

//   error => Promise.reject(error),
// );

const token = TokenService.getToken();

if (token != "") {
  services.setHeader();
}

app.component("font-awesome-icon", FontAwesomeIcon);
app.config.globalProperties.axios = axios;
app.config.globalProperties.filters = filters;
library.add(fas, far, fab);
app.use(VueSweetalert2);
app.use(VueSelect);

app.use(store).use(router).mount("#app");
